export default "__VITE_ASSET__3e236553__"